export default function (nga, admin, menu) {
    var _ename = 'productlists';
    var _epretty = 'Product Lists';
    var _entity = nga.entity(_ename);
    
    _entity.listView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID'),
            nga.field('code').label('Code').isDetailLink(true),
            nga.field('name').label('Name').isDetailLink(true)
        ])
        .sortField('name')
        .sortDir('asc')
        .listActions(['edit', 'show']);

    _entity.showView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID'),
            nga.field('code').label('Code'),
            nga.field('name').label('Name'),
            nga.field('children', 'reference_many')
                .targetEntity(nga.entity('products'))
                .permanentFilters({ types: ['track'] })
                .targetField(nga.field('code'))
                .label('Faixas')
        ]);
        
    _entity.editionView()
        .title('Edit ' + _epretty)
        .fields([
            nga.field('name').label('Name'),
            nga.field('children', 'reference_many')
                .targetEntity(nga.entity('products'))
                .permanentFilters({ types: ['track'] })
                .targetField(nga.field('code'))
                .remoteComplete(true)
                .label('Faixas')
        ]);
        
    _entity.creationView()
        .title('Create new ' + _epretty)
        .fields([
            nga.field('code').label('Code'),
            nga.field('name').label('Name'),
            nga.field('children', 'reference_many')
                .targetEntity(nga.entity('products'))
                .permanentFilters({ types: ['track'] })
                .targetField(nga.field('code'))
                .remoteComplete(true)
                .label('Faixas')
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/productlist.js